<template>
  <div>
    <div id="pdf" class="text-right">
      <button
        class="btn btn-primary"
        v-on:click="pdfgen"
        ref="button"
        :disabled="isButtonDisabled"
      >
        <spring-spinner
          :animation-duration="3000"
          :size="15"
          :sendEmail_loading="{ sendEmail_loading }"
          color="white"
          v-if="sendEmail_loading"
        />
        <div v-else-if="msg === 'Print'">
          {{ msg }}
          <i class="icon-printer ml-2"></i>
        </div>
        <div v-else>
          {{ msg }}
          <i class="icon-file-pdf ml-2"></i>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { SpringSpinner } from 'epic-spinners';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { PDFDocument } from 'pdf-lib';

export default {
  name: 'Pdfgen',
  components: {
    SpringSpinner
  },
  props: {
    companyLogo: String,
    isButtonDisabled: Boolean,
    msg: String,
    selectedEmployee: Object,
    allEmployeesReportData: Array,
    allEmployeesSelected: Boolean,
    printTotals: Array,
    printData: Array,
    searchDate: Array,
    statHoursWorked: Number,
    statDaysWorked: Number,
    statExemptHours: Number,
    statExemptDays: Number,
    multipleStats: Boolean,
    includeTimeCardData: Boolean,
    jobSpecificTotals: Array,
    reportTotals: Object
  },
  updated() {
    this.zip = new JSZip();
    this.attempts = 0;
  },
  data() {
    return {
      newLines: null,
      tikkerLogo:
        'data:image/png;base64,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',
      sendEmail_loading: false,
      zip: null,
      attempts: 0,
      hasStatTime: false,
      employeeStatTotals: null
    };
  },
  methods: {
    //This function dynamically generates the JSON with the companies logo
    generateLogo: function(dataURL, logoWidth) {
      let companyLogoJSON = {};
      if (dataURL != undefined && logoWidth != undefined) {
        companyLogoJSON = {
          image: `${dataURL}`,
          width: logoWidth,
          border: [false, false, false, false],
          margin: [40, 30, 0, 0]
        };
        return companyLogoJSON;
      } else {
        return companyLogoJSON;
      }
    },
    pdfgen: function(
      msg,
      selectedEmployee,
      allEmployeesReportData,
      printTotals,
      printData,
      searchDate,
      index,
      multipleEmployees
    ) {
      //had to do this because of weird issue where depending on whether I was calling the function directly or not, the objects I was receiving were different, but you can basically ignore this
      let allEmployeesSelected;
      let statHoursWorked;
      let statDaysWorked;
      let statExemptHours;
      let statExemptDays;

      if (multipleEmployees !== true) {
        allEmployeesSelected = this.allEmployeesSelected;
        msg = this.msg;
        selectedEmployee = this.selectedEmployee;
        allEmployeesReportData = this.allEmployeesReportData;
        printTotals = this.printTotals;
        printData = this.printData;
        searchDate = this.searchDate;
        statHoursWorked = this.statHoursWorked;
        statDaysWorked = this.statDaysWorked;
        statExemptHours = this.statExemptHours;
        statExemptDays = this.statExemptDays;
        index = 0;
      } else {
        statHoursWorked = allEmployeesReportData[index].statHoursWorked ? allEmployeesReportData[index].statHoursWorked.toFixed(2): null;
        statDaysWorked = allEmployeesReportData[index].statDaysWorked;
        statExemptHours = allEmployeesReportData[index].statExemptHours;
        statExemptDays = allEmployeesReportData[index].statExemptDays;
      }
      const findEmployeeIndex = element =>
        element.employee === selectedEmployee.id;
      // const printIndex = printTotals.findIndex(findEmployeeIndex);
      const dataIndex = printData.findIndex(findEmployeeIndex);

      //if all employees are selected, we emit an event which calls a function in payrollReport, this was just so I could use some of the existing functionality that chase had already coded
      if (allEmployeesSelected === true) {
        if (this.msg === 'Download') {
          this.$emit('download');
          return;
        } else if (this.msg === 'Email') {
          this.$emit('email');
          return;
        } else if (this.msg === 'Print') {
          this.$emit('print');
          return;
        }
      }
      // console.log('allemployeesselected', this.allEmployeesSelected);
      // console.log('Msg: ', msg);
      // console.log('selectedEmployee: ', selectedEmployee);
      // console.log('allEmployees report data: ', allEmployeesReportData);
      // console.log('allEmployees counter: ', index);
      // console.log('printTotals: ', printTotals);
      // console.log('printData: ', printData);
      // console.log('searchDate: ', searchDate);
      // console.log('index: ', index);
      // console.log('totals index: ', printIndex);
      // console.log('data index: ', dataIndex);
      // console.log('multipleEmployees: ', multipleEmployees);
      //create the pdf
      var pdfMake = require('pdfmake/build/pdfmake.js');
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require('pdfmake/build/vfs_fonts.js');
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      var docDefinition = {
        header: {
          columns: [
            //Company Logo
            this.generateLogo(this.companyLogo, 100),
            //Tiker logo
            [
              {
                image: `${this.tikkerLogo}`,
                width: 100,
                border: [false, false, false, false],
                style: 'tikkerLogo',
                margin: [0, 30, 20, 0],
                alignment: 'right'
              }
            ]
          ]
        },
        content: [
          //Employee name
          {
            text: `${selectedEmployee.name} `,
            style: 'employeeName',
            border: [false, false, false, false],
            alignment: 'center'
          },
          '\n\n',
          {
            columns: [
              {
                width: 100,
                text: 'Total Hours',
                style: 'subheader'
              },
              {
                width: 100,
                text: 'Regular Hours',
                style: 'subheader'
              },
              {
                width: 100,
                text: 'OT Hours',
                style: 'subheader'
              },
              //these are all variable and will not appear if equal to 0
              this.getTravelHeader(allEmployeesReportData, index),
              this.getOnCallHeader(allEmployeesReportData, index),
              this.getStatHeader(allEmployeesReportData, index)
            ]
          },
          '\n',
          {
            columns: [
              {
                width: 100,
                text: `${allEmployeesReportData[index].total.toFixed(2)}`,
                style: 'subheader2'
              },
              {
                width: 100,
                text: `${allEmployeesReportData[index].regularTotal.toFixed(
                  2
                )}`,
                style: 'subheader2'
              },
              {
                width: 100,
                text: `${allEmployeesReportData[index].otTotal.toFixed(2)}`,
                style: 'subheader2'
              },
              this.getTravelTotal(allEmployeesReportData, index),
              this.getOnCallTotal(allEmployeesReportData, index),
              this.getStatOverallTotal(allEmployeesReportData, index)
            ]
          }
          // {
          //   table: {
          //     widths: ['*'],
          //     body: [[' '], [' ']]
          //   },
          //   layout: {
          //     hLineWidth: function(i, node) {
          //       return i === 0 || i === node.table.body.length ? 0 : 2;
          //     },
          //     vLineWidth: function(i, node) {
          //       return 0;
          //     }
          //   }
          // }
        ],
        pageMargins: [40, 60, 40, 60],
        styles: {
          employeeName: {
            fontSize: 18,
            alignment: 'center',
            bold: true,
            margin: [0, 0, 0, 0]
          },
          subheader: {
            fontSize: 11,
            bold: true,
            alignment: 'center'
          },
          subheader2: {
            fontSize: 11,
            bold: true,
            color: 'blue',
            alignment: 'center'
          },
          statCalculationsHeader: {
            fontsize: 11,
            bold: true,
            alignment: 'right',
            decoration: 'underline'
          },
          statCalculations: {
            fontsize: 11,
            italics: true,
            alignment: 'right'
          },
          timeCardStyles: {
            fontSize: 7,
            bold: true
          },
          notesStyles: {
            fontSize: 7,
            color: '#ad466c',
            margin: [0, 0, 40, 0]
          },
          editCommentStyles: {
            fontSize: 7,
            color: '#ff7043'
          },
          tableHeader: {
            fontSize: 10
          }
        }
      };
      //loop through the printData and keep appending to the docDefinition, as there is an uknown amount of weeks selected.
      //loop through the weeks for each employee.
      for (let i = 0; i <= printData[dataIndex].data.length - 1; i++) {
        let pageBreakValue = '';
        if ((i + 1) % 2 == 0 && i != printData[dataIndex].data.length - 1) {
          pageBreakValue = 'after';
        }
        // Add more newlines at the begining of the page after
        // the first page so date range isnt
        // covered by company logo
        if (i > 1 && (i + 1) % 2 != 0) {
          this.newLines = '\n\n\n\n';
        } else {
          this.newLines = '\n';
        }
        docDefinition.content.push([
          this.newLines,
          {
            text: `${printData[dataIndex].data[i].week[0]} - ${printData[dataIndex].data[i].week[6]}`
          },
          '\n',
          //this.table is a helper function for building and formatting our table.
          this.table(
            printData[dataIndex].data[i].timeCards,
            printData[dataIndex].data[i].week,
            printTotals[dataIndex].totals[i],
            this.allEmployeesSelected
              ? this.jobSpecificTotals[
                  this.jobSpecificTotals.findIndex(
                    x => x.employee.id === selectedEmployee.id
                  )
                ].data[i]
              : this.jobSpecificTotals[i]
          ),
          '\n',
          this.timeCardDetails(printData[dataIndex].data[i].timeCards),
          {
            columns: [], //we need this empty column value here so we can dynmically insert the pagebreak. We cannot have a page break without following an element.
            pageBreak: pageBreakValue
          },
          '\n\n'
        ]);
      }
      if (this.hasStatTime) {
        docDefinition.content.push({
          text: `Stat Calculations`,
          style: 'statCalculationsHeader'
        });
        docDefinition.content.push({
          text: `${statHoursWorked} hour${
            statHoursWorked === 1 ? '' : 's'
          } / ${statDaysWorked} day${statDaysWorked === 1 ? '' : 's'}`,
          style: 'statCalculations'
        });
        docDefinition.content.push({
          text: `${statExemptDays} stat exempt day${
            statExemptDays === 1 ? '' : 's'
          }`,
          style: 'statCalculations'
        });
        docDefinition.content.push({
          text: `${statExemptHours} stat exempt hour${
            statExemptHours === 1 ? '' : 's'
          }`,
          style: 'statCalculations'
        });
      }
      // });
      let vm = this;
      //If all employees are selected and download is clicked, send the result to a zip file, which downloads once the end of the allemployeesreportdata array is reached
      if (msg === 'Download' && multipleEmployees) {
        return pdfMake.createPdf(docDefinition);
      } else if (msg === 'Download') {
        //TODO: supply the correct dates here.
        pdfMake
          .createPdf(docDefinition)
          .download(
            `${selectedEmployee.name} Payroll Report ${printData[dataIndex].data[0].week[0]}.pdf`
          );
      } else if (msg === 'Print') {
        pdfMake.createPdf(docDefinition).print();
      } else if (msg === 'Email') {
        this.sendEmail(selectedEmployee, pdfMake, docDefinition, searchDate);
      }
    },
    sendEmail: function(selectedEmployee, pdfMake, docDefinition, searchDate) {
      // this.sendEmail_loading = true;
      const pdfDocGenerator = pdfMake.createPdf(docDefinition);
      pdfDocGenerator.getBlob(async blob => {
        let employee = selectedEmployee;
        var formData = new FormData();
        formData.append('file', blob);
        let sendingParams = {
          name: employee.name,
          dates: [
            moment(searchDate[0]).format('MMM DD, YY'),
            moment(searchDate[1]).format('MMM DD, YY')
          ],
          company: this.$store.state.userCompanyName,
          email: employee.email
        };
        try {
          //let response = await axios
          //   .post(
          let response = await axios.post(
            // 'http://localhost:5000/timecardapp-87874/us-central1/sendEmailReport',
            'https://us-central1-timecardapp-87874.cloudfunctions.net/sendEmailReport',
            formData,
            {
              params: sendingParams
            }
          );
          if (response.status === 200) {
            this.showSuccess(
              `Payroll report has been sent to ${employee.email}`
            );
            // this.sendEmail_loading = false;
          }
          else {
            this.showError(
              `Error sending payroll report to ${employee.email}`
            );
            // this.sendEmail_loading = false;
          }
        } catch (error) {
          console.log(`Error sending payroll report: ${error}`);
          this.showError(`Error sending payroll report to ${employee.email}`);
          // this.sendEmail_loading = false;
        }
      });
    },

    async generatePDFBlob(name, pdfDocGenerator, shouldCollate) {
      //this function is called if all employees are selected and download is clicked.
      const wait = pdfData =>
        new Promise(resolve => {
          pdfData.getBlob(blob => {
            if (!shouldCollate) {
              this.zip.file(`${name}.pdf`, blob);
            }
            resolve(blob);
          });
        });
      return await wait(pdfDocGenerator);
    },

    downloadZipFile: async function() {
      let startDate = String(this.searchDate[0]);
      let endDate = String(this.searchDate[1]);
      this.zip.generateAsync({ type: 'blob' }).then(function(content) {
        saveAs(content, `${startDate.slice(0, 15)} - ${endDate.slice(0, 15)}`);
      });
    },
    buildTableBody: function(data, columns, totals, jobSpecificTotals) {
      //add empty slot to start of columns
      let newColumns = [...columns];
      newColumns.unshift('');
      newColumns.push('');
      let body = [];
      let hasTravelTime = false;
      let hasOnCallTime = false;
      let vm = this;
      body.push(newColumns);
      let regularHoursData = ['Regular Hours'];
      let otHoursData = ['OT Hours'];
      let totalHoursData = ['Total Hours'];
      let onCallHoursData = ['On Call Hours'];
      let travelTimeData = ['Travel Time'];
      let statHoursData = ['Stat Hours'];
      let jobSpecificHoursDataRegular = {};
      let jobSpecificHoursDataOT = {};
      //if jobSpecific times is enabled. add a list of all jobs for the week
      if (this.jobSpecificTimes) {
        for (let [key, value] of Object.entries(jobSpecificTotals.regular)) {
          if (jobSpecificHoursDataRegular[`${key}`] === undefined) {
            jobSpecificHoursDataRegular[`${key}`] = [`${this.getJobName(key)}`];
          }
        }
        for (let [key, value] of Object.entries(jobSpecificTotals.ot)) {
          if (jobSpecificHoursDataOT[`${key}`] === undefined) {
            jobSpecificHoursDataOT[`${key}`] = [`${this.getJobName(key)} `];
          }
        }
      }

      //loops the data and get each type of time for each day.
      data.forEach(function(row) {
        regularHoursData.push(row.regularHours.toString());
        otHoursData.push(row.otHours.toString());
        totalHoursData.push(row.totalHours.toString());
        //check to see if the on call, travel, or stat times are present. If they are, then we add them to the table.
        if (row.onCallHours) {
          onCallHoursData.push(row.onCallHours.toString());
          if (Number(row.onCallHours, 10) > 0) {
            hasOnCallTime = true;
          }
        } else {
          onCallHoursData.push('');
        }
        if (row.travelTime) {
          travelTimeData.push(row.travelTime.toString());
          if (Number(row.travelTime, 10) > 0) {
            hasTravelTime = true;
          }
        } else {
          travelTimeData.push('');
        }
        if (row.statTime) {
          statHoursData.push(row.statTime.toString());
          if (Number(row.statTime, 10) > 0) {
            vm.hasStatTime = true;
          }
        } else {
          statHoursData.push('');
        }

        if (vm.jobSpecificTimes) {
          if (row.jobSpecificHoursSummary) {
            for (let [key, value] of Object.entries(
              jobSpecificHoursDataRegular
            )) {
              jobSpecificHoursDataRegular[`${key}`].push(
                row.jobSpecificHoursSummary.regular[`${key}`]
                  ? row.jobSpecificHoursSummary.regular[`${key}`]
                  : 0
              );
            }

            for (let [key, value] of Object.entries(jobSpecificHoursDataOT)) {
              jobSpecificHoursDataOT[`${key}`].push(
                row.jobSpecificHoursSummary.ot[`${key}`]
                  ? row.jobSpecificHoursSummary.ot[`${key}`]
                  : 0
              );
            }
          } else {
            for (let job in jobSpecificHoursDataRegular) {
              jobSpecificHoursDataRegular[job].push(0);
            }

            for (let job in jobSpecificHoursDataOT) {
              jobSpecificHoursDataOT[job].push(0);
            }
          }
        }
      });

      for (let [key, value] of Object.entries(jobSpecificHoursDataRegular)) {
        jobSpecificHoursDataRegular[`${key}`].push(
          jobSpecificTotals.regular[`${key}`]
        );
      }

      for (let [key, value] of Object.entries(jobSpecificHoursDataOT)) {
        jobSpecificHoursDataOT[`${key}`].push(jobSpecificTotals.ot[`${key}`]);
      }
      //push the totals to the end of the table.
      regularHoursData.push(totals.regularTotal);
      otHoursData.push(totals.otTotal);
      totalHoursData.push(totals.total);
      onCallHoursData.push(totals.onCallHoursTotal);
      travelTimeData.push(totals.travelTimeTotal);
      statHoursData.push(totals.statTotal);
      body.push(regularHoursData);
      if (this.jobSpecificTimes) {
        for (let job in jobSpecificHoursDataRegular) {
          body.push(jobSpecificHoursDataRegular[job]);
        }
      }
      body.push(otHoursData);
      if (this.jobSpecificTimes) {
        for (let job in jobSpecificHoursDataOT) {
          body.push(jobSpecificHoursDataOT[job]);
        }
      }
      if (hasOnCallTime) {
        body.push(onCallHoursData);
      }
      if (hasTravelTime) {
        body.push(travelTimeData);
      }
      if (this.hasStatTime) {
        body.push(statHoursData);
      }
      body.push(totalHoursData);
      return body;
    },
    table: function(data, columns, totals, jobSpecificTotals) {
      return {
        table: {
          headerRows: 1,
          body: this.buildTableBody(data, columns, totals, jobSpecificTotals)
        }
      };
    },
    timeCardDetails: function(timeCards) {
      //only run this if the user selected to include timecard info
      if (this.includeTimeCardData) {
        //loop over the timecards and format them into a JSON object that can be parsed by pdfMake
        let returnedTimeCards1 = {
          table: {
            headerRows: 1,
            body: [],
            style: 'timeCardStyles',
            widths: ['*', '*', '*', '*']
          },
          layout: 'lightHorizontalLines'
        };
        let returnedTimeCards2 = {
          table: {
            headerRows: 1,
            body: [],
            style: 'timeCardStyles',
            widths: ['*', '*', '*', '*']
          },
          layout: 'lightHorizontalLines'
        };
        let timeCardHeader = [];
        let timeCardBody = [];
        let timeCardHeader2 = [];
        let timeCardBody2 = [];
        //only add timecards tot he array if they have times, so there are no empty timecards.
        timeCards.forEach((timeCard, index) => {
          //append the first 4 timecards to the first table. The last 4 timecards go to the second table.
          if (timeCardHeader.length <= 3) {
            if (timeCard.times != undefined) {
              //the date is the header of the column in the table.
              timeCardHeader.push({
                text: timeCard.date,
                style: 'tableHeader'
              });
              //loop the times to get all start and end times.
              let times = [];
              timeCard.times.forEach(time => {
                //put the start and end time each as a row in the column.
                times.push({
                  text: `${time.startTime} - ${time.endTime}`,
                  style: 'timeCardStyles'
                });
                if (time.notes != '' && time.notes != undefined) {
                  //if there are any notes, put them beneath the time.
                  times.push({
                    text: `NOTES: ${time.notes}`,
                    style: 'notesStyles'
                  });
                }
              });
              if (timeCard.comments != undefined) {
                //loop the comments, incse there are multiple.
                timeCard.comments.forEach(comment => {
                  //if there are any edit comments, put them beneath the time.
                  times.push({
                    text: `EDIT COMMENT: ${comment.comment}`,
                    style: 'editCommentStyles'
                  });
                });
              }
              timeCardBody.push(times);
            }
          } else {
            if (timeCard.times != undefined) {
              //the date is the header of the column in the table.
              timeCardHeader2.push({
                text: timeCard.date,
                style: 'tableHeader'
              });
              //loop the times to get all start and end times.
              let times = [];
              timeCard.times.forEach(time => {
                //put the start and end time each as a row in the column.
                times.push({
                  text: `${time.startTime} - ${time.endTime}`,
                  style: 'timeCardStyles'
                });
                if (time.notes != '' && time.notes != undefined) {
                  //if there are any notes, put them beneath the time.
                  times.push({
                    text: `NOTES: ${time.notes}`,
                    style: 'notesStyles'
                  });
                }
              });
              if (timeCard.comments != undefined) {
                //loop the comments, incse there are multiple.
                timeCard.comments.forEach(comment => {
                  //if there are any edit comments, put them beneath the time.
                  times.push({
                    text: `EDIT COMMENT: ${comment.comment}`,
                    style: 'editCommentStyles'
                  });
                });
              }
              timeCardBody2.push(times);
            }
          }
        });
        returnedTimeCards1.table.body.push(timeCardHeader);
        returnedTimeCards1.table.body.push(timeCardBody);
        returnedTimeCards2.table.body.push(timeCardHeader2);
        returnedTimeCards2.table.body.push(timeCardBody2);
        let returnedTimeCards = [returnedTimeCards1, '\n', returnedTimeCards2];
        return returnedTimeCards;
      } else {
        return null;
      }
    },
    getTravelTotal: function(dataArray, index, weekIndex) {
      if (weekIndex == null) {
        if (Number(dataArray[index].travelTimeTotal, 10) > 0) {
          return {
            width: 100,
            text: `${dataArray[index].travelTimeTotal}`,
            style: 'subheader2'
          };
        }
      } else {
        if (
          Number(dataArray[index].totals[weekIndex].travelTimeTotal, 10) > 0
        ) {
          return {
            width: 100,
            text: `${dataArray[index].totals[weekIndex].travelTimeTotal}`,
            style: 'subheader2'
          };
        }
      }
    },
    getTravelHeader: function(dataArray, index, weekIndex) {
      if (weekIndex == null) {
        if (Number(dataArray[index].travelTimeTotal, 10) > 0) {
          return {
            width: 100,
            text: 'Travel Time',
            style: 'subheader'
          };
        }
      } else {
        if (
          Number(dataArray[index].totals[weekIndex].travelTimeTotal, 10) > 0
        ) {
          return {
            width: 100,
            text: 'Travel Time',
            style: 'subheader'
          };
        }
      }
    },
    getOnCallTotal: function(dataArray, index, weekIndex) {
      if (weekIndex == null) {
        if (Number(dataArray[index].onCallHoursTotal, 10) > 0) {
          return {
            width: 100,
            text: `${dataArray[index].onCallHoursTotal}`,
            style: 'subheader2'
          };
        }
      } else {
        if (
          Number(dataArray[index].totals[weekIndex].onCallHoursTotal, 10) > 0
        ) {
          return {
            width: 100,
            text: `${dataArray[index].totals[weekIndex].onCallHoursTotal}`,
            style: 'subheader2'
          };
        }
      }
    },
    getOnCallHeader: function(dataArray, index, weekIndex) {
      if (weekIndex == null) {
        if (Number(dataArray[index].onCallHoursTotal, 10) > 0) {
          return {
            width: 100,
            text: 'On Call Hours',
            style: 'subheader'
          };
        }
      } else {
        if (
          Number(dataArray[index].totals[weekIndex].onCallHoursTotal, 10) > 0
        ) {
          return {
            width: 100,
            text: 'On Call Hours',
            style: 'subheader'
          };
        }
      }
    },
    getStatTotal: function(dataArray, index, weekIndex) {
      if (Number(dataArray[index].totals[weekIndex].statTotal, 10) > 0) {
        return {
          width: 100,
          text: `${dataArray[index].totals[weekIndex].statTotal}`,
          style: 'subheader2'
        };
      }
    },
    getStatOverallTotal: function(dataArray, index) {
      if (this.allEmployeesSelected) {
        if (Number(dataArray[index].statTotal) > 0) {
          // changed here from > to >=
          return {
            width: 100,
            text: `${Number(dataArray[index].statTotal)}`,
            style: 'subheader2'
          };
        }
      } else {
        if (this.employeeStatTotals > 0) {
          return {
            width: 100,
            text: `${Number(this.employeeStatTotals).toFixed(2)}`,
            style: 'subheader2'
          };
        }
      }
    },
    getStatHeader: function(dataArray, index, weekIndex) {
      //added the if statement to check for null week index, as the report totals are using the allEmployeeReportData to check if there
      //is a stat value and the weekly totals are using printData. The arrays are formatted differently now.
      if (weekIndex == null) {
        if (
          Number(dataArray[index].statTotal, 10) > 0 ||
          this.employeeStatTotals > 0
        ) {
          return {
            width: 100,
            text: 'Stat Hours',
            style: 'subheader'
          };
        }
      } else {
        if (Number(dataArray[index].totals[weekIndex].statTotal, 10) > 0) {
          return {
            width: 100,
            text: 'Stat Hours',
            style: 'subheader'
          };
        }
      }
    },
    getJobName(id) {
      if (id && id !== 'default') {
        let job = this.jobs.find(x => x.id === id);
        return job.description;
      }
      return 'Unassigned';
    },
    showSuccess: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'success'
      });
    },
    showError: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'error'
      });
    },
    async mergePdfs(blobs) {
      const mergedPdf = await PDFDocument.create();
      for (const blob of blobs) {
        const arrayBuffer = await blob.arrayBuffer();
        const pdf = await PDFDocument.load(arrayBuffer);
        const copiedPages = await mergedPdf.copyPages(
          pdf,
          pdf.getPageIndices()
        );
        copiedPages.forEach(page => {
          mergedPdf.addPage(page);
        });
      }
      return mergedPdf.save();
    }
  },
  computed: {
    jobSpecificTimes() {
      return this.$store.state.jobSpecificTimes;
    },
    jobs() {
      return this.$store.state.jobs;
    }
  },
  watch: {
    'reportTotals.statTotal': function(newVal, oldVal) {
      this.employeeStatTotals = newVal;
    }
  }
};
</script>

<style scoped></style>
